import React, { Fragment, useEffect, useState, useContext } from 'react';
import PropTypes from "prop-types";

import ModalContentWrapper from "./ModalContentWrapper";

import './ModalUploadDocument.scss';

import { useForm } from "react-hook-form";

import DropdownUserTypes from "root/ReactHookForm/ui/DropdownUserTypes";
import {
    createProviderStaff,
    deleteProviderStaff,
    getUserDetails, promoteProviderStaff,
    resendProviderStaffInvite,
    updateProviderStaff
} from "root/DataFunctions/ProviderFns";
import { getDataFromResponse, getNamedCustomDataFromResponse } from "root/DataFunctions/BaseDataFns";
import { CreateUserResponseCodes, UserAccountStatus, UserType } from "root/DataFunctions/Constants";
import GlobalContext from "root/Contexts/GlobalContext";

const ErrorDiv = ( props ) =>
{
    const style = { marginTop: '5px', color: 'red' };

    return <div style={ style }>{ props.children }</div>
}

export const AddStaffModalMode = {
    CREATE: 'create',
    EDIT: 'edit',
    RESEND: 'resend',
    DELETE: 'delete',
    PROMOTE: 'promote'
};

const ModalAddStaff = ( {  onSaveCompleted, onClose, provider_id, user_id, params, mode }  ) =>
{
    const [ data, setData ] = useState ( { loading: true, data: [] } );
    const [ createError, setCreateError ] = useState ( { hasError: false, errorState: [] });
    const [ buttonState, setButtonDisabled ] = useState (false) ;

    const sessionContext = useContext ( GlobalContext ) ;

    const { register, control, handleSubmit, setFocus, setValue, watch, formState: { errors: formErrors } } = useForm (
        {
            defaultValues: {
                user: {
                    firstname: '',
                    surname: '',
                    email_address: '',
                    telephone: '',
                    user_type: null
                }
            }
        } );

    const primaryButtonStyle = {
        marginRight: '0px',
        marginLeft: '10px'
    };

    useEffect ( () =>
    {
        if ( mode === AddStaffModalMode.EDIT || mode === AddStaffModalMode.DELETE || mode === AddStaffModalMode.RESEND || mode === AddStaffModalMode.PROMOTE )
        {
            getData ();
        }
        else
        {
            setData( { loading: false, data: [] }) ;
        }
    }, [] );

    const getData = () =>
    {
        getUserDetails (   provider_id, user_id, ( response ) =>
        {
            const returnData = getDataFromResponse ( response );

            const user = returnData[0] ;

            // Set the form values to the new values loaded from the database
            setValue ( 'user', {
                firstname: user.firstname,
                surname: user.surname,
                email_address: user.email,
                telephone: user.telephone,
                user_type: { value: +(user.user_type_id), label: user.type_description }
            }) ;

            setData ( { loading: false, data: returnData } )
        } )
    }

    useEffect ( () =>
    {
        if ( data.loading === false )
        {
            setFocus ( "user.firstname" );
        }
    }, [ data.loading ] );


    const saveUser = ( formData, onComplete ) =>
    {
        switch ( mode )
        {
            case AddStaffModalMode.CREATE:

                setButtonDisabled ( true );

                createProviderStaff( provider_id, formData, ( response ) =>
                {
                    setButtonDisabled ( false );

                    const createResponse = getNamedCustomDataFromResponse( response, 'response') ;

                    if ( createResponse.length !== 0 )
                    {
                        const code = createResponse.response_code ;

                        if ( code === CreateUserResponseCodes.USER_CREATED_IN_PROVIDER || code === CreateUserResponseCodes.USER_CREATED_IN_OTHER_PROVIDER )
                        {
                            if ( onComplete !== null )
                            {
                                onSaveCompleted ( response );
                            }
                        }
                        else
                        {
                            setCreateError ( { hasError: true, errorState: createResponse }) ;
                        }
                    }
                } )
                break ;
            case AddStaffModalMode.EDIT:

                setButtonDisabled ( true );

                updateProviderStaff( provider_id, user_id, formData, ( response ) =>
                {
                    setButtonDisabled ( false );

                    if ( onComplete !== null )
                    {
                        onSaveCompleted ( response );
                    }
                } )
                break ;

            case AddStaffModalMode.RESEND:

                setButtonDisabled ( true );

                resendProviderStaffInvite( provider_id, user_id, formData, ( response ) =>
                {
                    setButtonDisabled ( false );

                    if ( onComplete !== null )
                    {
                        onSaveCompleted ( response );
                    }
                } )
                break ;

            case AddStaffModalMode.DELETE:

                setButtonDisabled ( true );

                deleteProviderStaff( provider_id, user_id, formData , ( response ) =>
                {
                    setButtonDisabled ( false );

                    if ( onComplete !== null )
                    {
                        onSaveCompleted ( response );
                    }
                } )
                break ;

            case AddStaffModalMode.PROMOTE:

                setButtonDisabled ( true );

                promoteProviderStaff( provider_id, user_id, formData , ( response ) =>
                {
                    setButtonDisabled ( false );

                    if ( onComplete !== null )
                    {
                        onSaveCompleted ( response );
                    }
                } )
                break ;
        }
    }

    const onClickGenerate = () =>
    {
        handleSubmit ( onSubmit ) ();
    }

    const onClickCancel = () =>
    {
        onClose ();
    }

    const onSubmit = ( formData ) =>
    {
        console.log ( formData );

        if ( mode === AddStaffModalMode.RESEND )
        {
            formData.user.resend_invite = 1;
        }
        else if ( userInviteFailed() )
        {
            if ( formData.email_address !== data.data[0].email )
            {
                // If the email address changed, and the account is in failed state, resend the email when updating the address
                formData.user.resend_invite = 1;
            }
        }

        saveUser ( formData );
    }

    const validateDropdown = ( val ) =>
    {
        if ( val.value === 0 )
        {
            return "You must select a user Type";
        }
    }

    const validateEmail = ( val ) =>
    {
        if ( !String(val)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            ))
        {
            return "You must enter a valid email address";
        }
    }

    const userInviteFailed = () =>
    {
        if ( mode === AddStaffModalMode.EDIT )
        {
            if ( data.data[0].account_active === UserAccountStatus.FAILED )
            {
                return true ;
            }
        }

        return false ;
    }

    const hiliteStyle = {
        color: 'var(--s360-icon-red)',
        fontStyle: 'italic'
    }

    const failedInviteRow = () =>
    {
        if ( userInviteFailed() )
        {
            return (
                <div className='row'>
                    <div className='col-md-12'>
                        <span style={hiliteStyle}>The invitation to register for this user failed. If you modify the email address, another invite will be sent to the new address.</span>
                    </div>
                </div>
            )
        }
    }

    const readOnly = mode === AddStaffModalMode.RESEND || mode === AddStaffModalMode.DELETE || mode === AddStaffModalMode.PROMOTE ;
    const dropdownReadOnly = readOnly || mode === AddStaffModalMode.EDIT ;

    const formContent = () =>
    {
        const suppressAdminUser = provider_id !== null ;
        const suppressDSLUser = provider_id === null ;

        const requireFields = mode !== AddStaffModalMode.RESEND ;

        return (
            <Fragment>
                <div className='buy-card-right'>
                    <p>{getSubtitle()}</p>

                    { data.loading === false && failedInviteRow() }

                    { data.loading === false && <form className='registration-form' onSubmit={ handleSubmit ( onSubmit ) }>

                        <div className='row'>
                            <div className='col-md-6'>
                                <label>First Name</label>
                                <input className='form-control' readOnly={ readOnly } { ...register ( "user.firstname", { required: requireFields } ) } />
                                { formErrors.user?.firstname && <ErrorDiv>Please enter first name</ErrorDiv> }
                            </div>
                            <div className='col-md-6'>
                                <label>Surname</label>
                                <input className='form-control' readOnly={ readOnly } { ...register ( "user.surname", { required: requireFields } ) } />
                                { formErrors.user?.surname && <ErrorDiv>Please enter last name</ErrorDiv> }
                            </div>
                        </div>

                        { mode === AddStaffModalMode.EDIT && sessionContext.user_type === UserType.USER_TYPE_LOCAL_AUTHORITY_MANAGER && <div className='row'>
                            <div className='col-md-12'>
                                <label>User Name</label>
                                <input className='form-control' readOnly={ true } disabled value={data.data[0].username} />
                            </div>
                        </div> }

                        <div className='row'>
                            <div className='col-md-6'>
                                <label>Email Address</label>
                                <input className='form-control' readOnly={ readOnly } { ...register ( "user.email_address", { required: requireFields, validate: validateEmail } ) } />
                                { formErrors.user?.email_address && <ErrorDiv>Please enter an email address</ErrorDiv> }
                            </div>
                            <div className='col-md-6'>
                                <label>Phone (Optional)</label>
                                <input className='form-control' readOnly={ readOnly } { ...register ( "user.telephone", { required: false } ) } />
                                { formErrors.user?.telephone && <ErrorDiv>Please enter a telephone number</ErrorDiv> }
                            </div>
                        </div>

                        <label>User Type</label>
                        <DropdownUserTypes readOnly={ dropdownReadOnly } control={ control } name='user.user_type' rules={{ required: true, validate: validateDropdown}} placeholder='Please select a user type' isSearchable={ true }  suppressAdminUser={suppressAdminUser} suppressDSLUser={suppressDSLUser}/>
                        { formErrors.user?.user_type && <ErrorDiv>{ formErrors.user.user_type.message }</ErrorDiv> }

                        <div className='modal-button-row'>
                            <button type="button" onClick={ onClickCancel }
                                    className="btn btn-icon btn-secondary btn-icon-right btn-small">Cancel<i className="et-arrow-bold-left"/></button>
                            <button disabled={buttonState} type="button" onClick={ onClickGenerate } style={ primaryButtonStyle }
                                    className="btn btn-icon btn-red btn-primary btn-icon-right btn-small">{  getSaveButtonText() }<i className="et-check"/></button>
                        </div>
                    </form> }
                </div>
            </Fragment>
        )
    }

    const formContentCreateError = () =>
    {
        return (
            <div className='buy-card-right' style={{textAlign: 'center'}}>

                <h4 style={{color: 'red'}}>Create User Failed - User already exists</h4>

                <p>Click the OK button below to return</p>

                <div className='modal-button-row center'>
                    <button type="button" onClick={ onClickCancel } className="btn btn-icon btn-secondary btn-icon-right btn-small">Ok<i className="et-arrow-bold-left"/></button>
                </div>
            </div>
        )
    }

    const formContentCreateErrorAnotherProvider = () =>
    {
        return (
            <div className='buy-card-right' style={{textAlign: 'center'}}>

                <h4 style={{color: 'red'}}>Create User Failed - User already exists at another provider</h4>

                <p>You will need to contact your system administrator to allow this user access to your data</p>

                <p>Click the OK button below to return</p>

                <div className='modal-button-row center'>
                    <button type="button" onClick={ onClickCancel } className="btn btn-icon btn-secondary btn-icon-right btn-small">Ok<i className="et-arrow-bold-left"/></button>
                </div>
            </div>
        )
    }

    const getSaveButtonText = () =>
    {
        switch ( mode )
        {
            case AddStaffModalMode.EDIT:
                return "Save Changes"
            case AddStaffModalMode.CREATE:
                return 'Create New User'
            case AddStaffModalMode.RESEND:
                return 'Re-send Invite'
            case AddStaffModalMode.DELETE:
                return 'Confirm Delete'
            case AddStaffModalMode.PROMOTE:
                return 'Confirm Promotion'
        }
    }

    const getTitle = () =>
    {
        switch ( mode )
        {
            case AddStaffModalMode.EDIT:
                return 'Edit User Details'
            case AddStaffModalMode.CREATE:
                return 'Create Staff Member'
            case AddStaffModalMode.DELETE:
                return 'Delete Staff Member'
            case AddStaffModalMode.PROMOTE:
                return 'Promote Staff Member to PRIMARY'
            case AddStaffModalMode.RESEND:
                return 'Re-Send Staff User Invite'
        }
    }

    const getSubtitle = () =>
    {
        switch ( mode )
        {
            case AddStaffModalMode.EDIT:
                return "Complete the fields below and click SAVE to update the user's details." ;
            case AddStaffModalMode.RESEND:
                return "You are about to re-send this user's new user invitation." ;
            case AddStaffModalMode.CREATE:
                return 'Complete the fields below and click SAVE to create a new user.'
            case AddStaffModalMode.DELETE:
                return 'Please ensure you are deleting the correct user. Click CONFIRM below to delete.'
            case AddStaffModalMode.PROMOTE:
                return 'Please ensure you are promoting the correct user to PRIMARY DSL. This will remove PRIMARY DSL status from the existing user. Click CONFIRM below to action.'
        }
    }

    return (
        <ModalContentWrapper className="modal-wrapper">
            <h3>{ getTitle() }</h3>
            <div className='buy-card'>
                <div>
                    <span className='glyphicon glyphicon-file' style={ { color: 'var(--vschool-mild-blue)', fontSize: '15rem', marginTop: '30px' } }/>
                </div>
                { createError.hasError === false && formContent () }
                { createError.hasError === true && createError.errorState.response_code === CreateUserResponseCodes.EXISTS_IN_PROVIDER && formContentCreateError () }
                { createError.hasError === true && createError.errorState.response_code === CreateUserResponseCodes.EXISTS_IN_OTHER_PROVIDER && formContentCreateErrorAnotherProvider () }
            </div>
        </ModalContentWrapper>
    )
}

export default ModalAddStaff;

ModalAddStaff.propTypes = {
    params: PropTypes.object,
    mode: PropTypes.oneOf ( [AddStaffModalMode.EDIT, AddStaffModalMode.CREATE, AddStaffModalMode.DELETE, AddStaffModalMode.RESEND, AddStaffModalMode.PROMOTE ]),
    user_id: PropTypes.string,
};
